import { render, staticRenderFns } from "./ArtikelDetails.vue?vue&type=template&id=4ae8cbc6"
import script from "./ArtikelDetails.vue?vue&type=script&lang=js"
export * from "./ArtikelDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports